import RegisterPageBody from "../components/registerPage/RegisterPageBody";

const RegisterPage = () => {
    return(
        <RegisterPageBody/>
    )
}

export default RegisterPage;